import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/depop-tips';

export default function Example() {
  return (
    <>
      <Head>
        <title>The 10 Tips for a Successful Depop Store - The Depop Seller Guide</title>
        <meta
          name='description'
          content='Looking for some basic tips and tricks to have a successful Depop store? Here are 10 tips and tricks that can help you get more sales!'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/depop-tips' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/depop-tips' />
        <meta property='og:title' content='The 10 Tips for a Successful Depop Store - The Depop Seller Guide' />
        <meta
          property='og:description'
          content='Looking for some basic tips and tricks to have a successful Depop store? Here are 10 tips and tricks that can help you get more sales!'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='2021-09-20T00:00:00.000Z' />
        <meta property='article:modified_time' content='2021-09-20T00:00:00.000Z' />
        <meta property='article:tag' content='Depop' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
